export default "__VITE_ASSET__Bbn74ALY__"